export const ro = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'Acasa',
  forYou: 'Pentru tine',
  myList: 'Lista mea',
  profile: 'Profil',
  userProfile: 'Profil utilizator',

  // Authentication
  signIn: 'Conectare',
  signUp: 'Inregistrare',
  signOut: 'Deconectare',
  signInWithApple: 'Conectare cu Apple',
  signUpWithApple: 'Inregistrare cu Apple',
  signInWithGoogle: 'Conectare cu Google',
  signUpWithGoogle: 'Inregistrare cu Google',
  appleSignInFailed: 'Conectarea Apple a esuat. Va rugam sa incercati din nou.',
  appleAuthExpired: 'Codul Apple a expirat',
  appleAuthRetrying: 'Reincercare automata...',
  appleAuthRetryFailed: 'Conectarea Apple a esuat. Va rugam sa incercati din nou.',
  appleAuthMaxRetriesReached: 'Prea multe incercari. Va rugam sa incercati mai tarziu.',
  appleSignInCancelled: 'Conectarea Apple a fost anulata.',
  appleAccountAlreadyExists: 'Un cont cu acest Apple ID exista deja. Va rugam sa va conectati.',
  appleAccountNotFound: 'Niciun cont gasit cu acest Apple ID. Va rugam sa va inregistrati mai intai.',
  googleSignInFailed: 'Conectarea Google a esuat. Va rugam sa incercati din nou.',
  googleAuthRetrying: 'Reincercare automata...',
  googleAuthMaxRetriesReached: 'Prea multe incercari. Va rugam sa incercati mai tarziu.',
  or: 'sau',
  email: 'Email',
  emailOrPhone: 'Email sau Telefon',
  enterEmail: 'Introduceti email-ul',
  enterEmailOrPhone: 'Introduceti email-ul sau numarul de telefon',
  emailOrPhonePlaceholder: 'email@exemplu.ro sau +40712345678',
  signInRequired: 'Conectare necesara',
  toWatchThisEpisode: 'Pentru a viziona acest episod',
  toAddEpisodeToFavorites: 'Pentru a adauga acest episod la favorite',
  pleaseSignInToWatch: 'Va rugam sa va conectati pentru a viziona acest episod',
  pleaseSignInToAddFavorite: 'Va rugam sa va conectati pentru a adauga acest episod la favorite',
  pleaseSignInToAddSerieFavorite: 'Va rugam sa va conectati pentru a adauga acest serial la favorite',
  pleaseSignInToSubscribe: 'Va rugam sa va conectati pentru a va abona',
  pleaseSignInToAccessRewards: 'Va rugam sa va conectati pentru a accesa toate functiile si a va urmari recompensele.',
  subscriptionRequired: 'Abonament necesar',
  episodeRequiresPremium: 'Acest episod necesita un abonament Premium',

  // Force update
  updateRequired: 'Actualizare necesara',
  currentVersion: 'Versiunea curenta',
  requiredVersion: 'Versiunea necesara',
  updateNow: 'Actualizeaza acum',
  appCannotBeUsedWithoutUpdate: 'Aplicatia nu poate fi utilizata fara actualizare',
  forceUpdateDefaultMessage: 'O noua versiune a aplicatiei este disponibila. Va rugam sa actualizati pentru a continua utilizarea aplicatiei.',

  // Recommended update
  updateAvailable: 'Actualizare disponibila',
  recommendedVersion: 'Versiunea recomandata',
  updateButton: 'Actualizeaza',
  laterButton: 'Mai tarziu',
  updateWillBeShownAgainIn24Hours: 'Aceasta actualizare va fi afisata din nou in 24 de ore',
  recommendedUpdateMessage: 'O noua versiune a aplicatiei cu imbunatatiri si functii noi este disponibila. Recomandam actualizarea pentru cea mai buna experienta.',

  // Errors
  error: 'Eroare',
  pleaseFillAllFields: 'Va rugam sa completati toate campurile',
  failedToCreateAccount: 'Crearea contului a esuat',
  invalidCredentials: 'Credentiale invalide',
  accountDisabled: 'Acest cont a fost dezactivat',
  emailAlreadyExists: 'Acest email este deja utilizat de un alt cont',
  phoneAlreadyExists: 'Acest numar de telefon este deja utilizat de un alt cont',
  invalidEmailFormat: 'Va rugam sa introduceti o adresa de email valida',
  invalidPhoneFormat: 'Va rugam sa introduceti un numar de telefon valid',
  accountMergeNotSupported: 'Un cont cu aceasta adresa de email exista deja. Va rugam sa va conectati folosind metoda originala de conectare.',

  // Content
  searchDramas: 'Cauta seriale...',
  noResultsFound: 'Niciun rezultat gasit pentru "{query}"',
  searchResultsOne: '1 rezultat pentru "{query}"',
  searchResultsMany: '{count} rezultate pentru "{query}"',
  allSeries: 'Toate serialele',
  topCharts: 'Top',
  recommendedForYou: 'Recomandate pentru tine',
  basedOnPreferences: 'Pe baza preferintelor tale',
  continueWatching: 'Continua vizionarea',
  resumeWatching: 'Reia vizionarea',
  similarToWatched: 'Similar cu ce ai vizionat',
  trendingSearches: 'Cautari populare',
  noSeriesInProgress: 'Niciun serial in curs',
  startWatchingToSee: 'Incepe sa vizionezi un serial pentru a-l vedea aici',
  noContentAvailable: 'Niciun continut disponibil',
  checkSupabaseConfig: 'Va rugam sa verificati configuratia Supabase',

  // Series and episodes
  seasons: 'Sezoane',
  season: 'Sezon',
  episodes: 'Episoade',
  synopsis: 'Sinopsis',
  episode: 'Episod',
  play: 'Reda',
  swipeToSeeMore: 'Glisati pentru a vedea mai mult',
  myListAction: 'Lista mea',
  addToMyList: 'Adaugă la favorite',
  removeFromMyList: 'Elimină din favorite',
  popular: 'Popular',
  new: 'Nou',
  trending: 'In trend',
  highlight: 'Evidential',
  free: 'Gratuit',
  premium: 'Premium',
  premiumEpisode: 'Episod Premium',
  signInToUnlock: 'Conecteaza-te pentru deblocare',
  subscribeToWatch: 'Aboneaza-te pentru vizionare',

  // Profile
  subscribeToPremium: 'Treci la Premium',
  subscribeWithDCB: 'Treci la Premium cu DCB',
  dcbSubscribeModalTitle: 'Abonament prin plata mobila',
  dcbSubscribeLoading: 'Se pregateste plata...',
  dcbSubscribeError: 'Nu s-a putut incarca pagina de plata.',
  dcbSubscribeRetry: 'Reincearca',
  restorePurchases: 'Restaureaza achizitiile',
  purchaseProcessing: 'Se proceseaza...',
  subscriptionActivated: 'Abonament activat cu succes!',
  webPaymentUnavailable: 'Platile web nu sunt disponibile momentan. Va rugam sa incercati mai tarziu.',
  paymentInitializing: 'Sistemul de plata se initializeaza. Va rugam sa incercati din nou in cateva secunde.',
  loadingOffers: 'Se incarca ofertele...',
  purchasesRestored: 'Abonamentul dumneavoastra a fost restaurat cu succes! Aveti acum acces la tot continutul Premium.',
  noPurchasesToRestore: 'Nu s-au gasit abonamente active de restaurat. Daca credeti ca este o eroare, va rugam sa contactati suportul.',
  purchaseFailed: 'Achizitia a esuat. Va rugam sa incercati din nou.',
  restoreFailed: 'Restaurarea achizitiilor a esuat.',
  restoreNetworkError: 'Problemă de conexiune. Verifică conexiunea la internet și încearcă din nou.',
  restoreReceiptInUse: 'Acest cont de magazin este deja asociat cu alt profil. Conectează-te cu contul original pentru a folosi acest abonament.',
  noActiveSubscription: 'Nu s-a gasit niciun abonament activ de restaurat.',
  iapNotAvailable: 'Achizitiile in aplicatie nu sunt disponibile.',
  webPurchaseNotSupported: 'Achizitiile in aplicatie nu sunt disponibile pe web. Va rugam sa folositi aplicatia mobila.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Abonament Premium lunar',
  premiumSubscriptionTagline: 'Deblocheaza acces nelimitat la toate serialele si episoadele',
  whatYouGet: 'Ce primesti',

  // Profile subscription information
  profileSubscriptionDescription: 'Obtine acces nelimitat la toate serialele si episoadele cu abonamentul nostru lunar.',
  profileBenefit1: 'Vizioneaza orice episod din intreaga noastra biblioteca',
  profileBenefit2: 'Acces instant la toate episoadele noi',
  profileBenefit3: 'Experienta de vizionare fara reclame',

  premiumBenefit1: 'Acces nelimitat la toate serialele - orice episod, oricand',
  premiumBenefit2: 'Biblioteca completa de continut actual cu sute de episoade',
  premiumBenefit3: 'Acces instant la toate episoadele noi imediat dupa lansare',
  premiumBenefit4: 'Vizioneaza orice episod fara restrictii sau limitari',
  premiumBenefit5: 'Experienta de vizionare fara reclame pentru divertisment neintrerupt',
  premiumBenefit6: 'Streaming video de inalta calitate pentru cea mai buna experienta',
  premiumBenefit7: 'Acces pe toate dispozitivele tale - telefon, tableta si web',
  bestValue: 'Cea mai buna oferta',
  subscriptionIncludes: 'Acces complet la tot continutul',
  perMonth: '/luna',
  perWeek: '/saptamana',
  startSubscription: 'Incepe abonamentul',
  learnMoreAboutSubscription: 'Afla mai multe despre abonament',

  // Subscription terms
  subscriptionTerms: 'Veti fi taxat prin contul dumneavoastra la pretul afisat pe ecranul de abonament. Abonamentul se reinnoieste automat lunar, cu exceptia cazului in care il anulati cu cel putin 24 de ore inainte de data reinnoirii. Taxele sunt percepute cu 24 de ore inainte de sfarsitul perioadei curente de facturare.',

  // Subscription details modal
  subscriptionDetails: 'Detalii abonament',
  whatIsIncluded: 'Ce este inclus',
  subscriptionDetailsDescription: 'Abonamentul Premium lunar va ofera acces nelimitat la toate serialele si episoadele din biblioteca noastra. Aceasta include tot continutul actual si toate episoadele noi lansate in perioada abonamentului. Puteti viziona orice episod, oricand, pe oricare dintre dispozitivele dumneavoastra fara restrictii.',
  howBillingWorks: 'Cum functioneaza facturarea',
  billingDescription: 'Veti fi taxat prin contul dumneavoastra la pretul afisat pe ecranul de abonament. Abonamentul se reinnoieste automat in fiecare luna, cu exceptia cazului in care il anulati cu cel putin 24 de ore inainte de data reinnoirii. Taxele sunt percepute cu 24 de ore inainte de sfarsitul perioadei curente de facturare.',
  howToCancel: 'Cum sa anulezi',
  cancellationDescription: 'Puteti anula abonamentul oricand din setarile dispozitivului. Pentru iOS: Setari > [Numele tau] > Abonamente. Pentru Android: Google Play Store > Meniu > Abonamente. Selectati aceasta aplicatie si apasati Anuleaza abonamentul. Abonamentul ramane activ pana la sfarsitul perioadei curente de facturare.',
  cancellationDescriptionIos: 'Puteti anula abonamentul oricand din setarile dispozitivului. Pentru iOS: Setari > [Numele tau] > Abonamente. Selectati aceasta aplicatie si apasati Anuleaza abonamentul. Abonamentul ramane activ pana la sfarsitul perioadei curente de facturare.',
  cancellationDescriptionAndroid: 'Puteti anula abonamentul oricand din setarile dispozitivului. Pentru Android: Google Play Store > Meniu > Abonamente. Selectati aceasta aplicatie si apasati Anuleaza abonamentul. Abonamentul ramane activ pana la sfarsitul perioadei curente de facturare.',
  subscriptionExpiry: 'Ce se intampla cand abonamentul expira',
  expiryDescription: 'Daca anulati sau abonamentul expira, veti pierde accesul la continutul Premium. Cu toate acestea, istoricul de vizionare si favoritele vor fi salvate. Puteti reabona oricand pentru a recastiga acces complet la toate episoadele Premium.',
  deviceCompatibility: 'Compatibilitate dispozitive',
  compatibilityDescription: 'Abonamentul functioneaza pe toate platformele unde folositi acelasi cont. Conectati-va cu acelasi cont pe orice dispozitiv pentru a accesa beneficiile Premium.',
  helpFeedback: 'Ajutor si feedback',
  language: 'Limba',
  notifications: 'Notificari',
  notificationSettings: 'Setari notificari',
  pushNotifications: 'Notificari push',
  enabled: 'Activat',
  disabled: 'Dezactivat',
  enable: 'Activeaza',
  enabling: 'Se activeaza...',
  pushNotificationsEnabled: 'Notificarile push au fost activate cu succes',
  pushNotificationsDisabled: 'Notificari push dezactivate',
  enablePushNotificationsInSettings: 'Pentru a primi notificari, va rugam sa le activati din setarile dispozitivului.',
  openSettings: 'Deschide setarile',
  pushNotificationsEnabledDescription: 'Veti primi notificari pe acest dispozitiv',
  pushNotificationsDisabledDescription: 'Activati notificarile pentru a fi la curent',
  notificationCategories: 'Categorii de notificari',
  notificationCategoriesDescription: 'Alegeti ce tipuri de notificari doriti sa primiti',
  newEpisodes: 'Episoade noi',
  newEpisodesDescription: 'Fii notificat cand sunt lansate episoade noi',
  recommendations: 'Recomandari',
  recommendationsDescription: 'Sugestii personalizate de continut pentru tine',
  subscriptionReminders: 'Remindere abonament',
  subscriptionRemindersDescription: 'Remindere despre starea abonamentului tau',
  rewardsNotifications: 'Recompense si realizari',
  rewardsNotificationsDescription: 'Noutati despre recompensele si progresul tau',
  marketingNotifications: 'Marketing si promotii',
  marketingNotificationsDescription: 'Oferte speciale si continut promotional',
  failedToUpdatePreferences: 'Actualizarea preferintelor de notificare a esuat',
  failedToRequestPermission: 'Solicitarea permisiunii de notificare a esuat',
  signInToSavePreferences: 'Conectati-va pentru a salva preferintele de notificare pe toate dispozitivele',
  done: 'Gata',
  contactUs: 'Contacteaza-ne',
  settings: 'Setari',
  privacyPolicy: 'Politica de confidentialitate',
  privacySettings: 'Confidentialitate si consimtamant',
  cookieSettings: 'Setarile mele de cookie-uri',
  localStorage: 'Stocare locala',
  termsConditions: 'Termeni si conditii',
  legalNotice: 'Nota legala',
  pricingConditions: 'Conditii de pret',
  unsubscribe: 'Dezabonare',
  unsubscribeInfo: 'Informatii dezabonare',
  loadingUnsubscribeInfo: 'Se incarca informatiile de dezabonare...',
  unsubscribeContentNotAvailable: 'Informatiile de dezabonare nu sunt disponibile momentan.',
  dcbUnsubscribeButton: 'Anuleaza abonamentul meu',
  dcbUnsubscribeConfirmTitle: 'Confirmare',
  dcbUnsubscribeConfirmMessage: 'Esti sigur ca vrei sa anulezi abonamentul? Vei pierde accesul la continutul Premium.',
  dcbUnsubscribeSuccess: 'Abonamentul tau a fost anulat cu succes. Nu mai esti abonat la serviciu.',
  dcbUnsubscribeError: 'Nu s-a putut anula abonamentul. Va rugam sa contactati suportul pentru asistenta.',
  loadingPrivacyPolicy: 'Se incarca politica de confidentialitate...',
  privacyPolicyNotAvailable: 'Politica de confidentialitate nu este disponibila momentan.',
  loadingTermsConditions: 'Se incarca termenii si conditiile...',
  termsConditionsNotAvailable: 'Termenii si conditiile nu sunt disponibile momentan.',
  cookies: 'Cookie-uri',
  cookiesSection: 'Cookie-uri',
  legalSection: 'Informatii legale',
  loadingCookies: 'Se incarca informatiile despre cookie-uri...',
  cookiesNotAvailable: 'Informatiile despre cookie-uri nu sunt disponibile momentan.',
  loadingLegalNotice: 'Se incarca nota legala...',
  legalNoticeNotAvailable: 'Nota legala nu este disponibila momentan.',
  loadingPricingConditions: 'Se incarca conditiile de pret...',
  pricingConditionsNotAvailable: 'Conditiile de pret nu sunt disponibile momentan.',
  retry: 'Reincearca',
  noEmailApp: 'Nicio aplicatie de email nu este disponibila pe acest dispozitiv.',
  errorOpeningEmail: 'Nu s-a putut deschide aplicatia de email.',
  errorOpeningSettings: 'Nu s-au putut deschide setarile sistemului.',
  security: 'Securitate',

  // Loading and errors
  loading: 'Se incarca...',
  loadingContent: 'Se incarca continutul...',
  preparingVideo: 'Se pregateste videoclipul...',

  seasonNotFound: 'Sezonul nu a fost gasit',
  episodeNotFound: 'Episodul nu a fost gasit',
  rubriqueNotFound: 'Rubrica nu a fost gasita',

  // Video player

  loadingVideo: 'Se incarca videoclipul...',
  loadingPlayer: 'Se incarca playerul...',
  loadingEpisodes: 'Se incarca episoadele...',

  // Badges and labels
  min: 'min',
  enemiesToLovers: 'De la dusmani la iubiti',

  // Actions
  cancel: 'Anuleaza',
  delete: 'Sterge',
  remove: 'Elimina',
  removeFromList: 'Elimina din Lista mea',
  subscribe: 'Aboneaza-te',
  selectLanguage: 'Selecteaza limba',
  restartRequired: 'Repornire necesara',
  restartMessage: 'Va rugam sa reporniti aplicatia pentru a aplica noua directie de layout.',
  restartToApplyLanguage: 'Reporniti aplicatia pentru a aplica noua limba?',
  ok: 'OK',
  save: 'Salveaza',
  saving: 'Se salveaza...',
  editProfile: 'Editeaza profilul',
  pseudo: 'Pseudonim',
  enterPseudo: 'Introduceti pseudonimul',
  pseudoPlaceholder: 'Alege un nume unic (max. 16 caractere)',
  pseudoTaken: 'Acest pseudonim este deja folosit',
  pseudoInvalid: 'Acest pseudonim contine continut inadecvat',
  pseudoInvalidCharacters: 'Acest pseudonim contine caractere invalide',
  pseudoNotAccepted: 'Va rugam sa alegeti alt pseudonim, acesta nu poate fi acceptat',
  pseudoMaxLength: 'Pseudonimul trebuie sa aiba maxim 16 caractere',
  pseudoCharactersCount: '{{count}}/16 caractere',
  editPseudo: 'Editeaza pseudonimul',
  pseudoUpdated: 'Pseudonim actualizat cu succes',
  subtitles: 'Subtitrari',
  off: 'Oprit',
  noSubtitlesAvailable: 'Nu sunt disponibile subtitrari',
  playbackSpeed: 'Viteza de redare',
  normalSpeed: 'Normal',
  profileInformation: 'Informatii profil',
  dateOfBirth: 'Data nasterii',
  phoneNumber: 'Numar de telefon',
  enterPhoneNumber: 'Introduceti numarul de telefon',
  notProvided: 'Nespecificat',
  dateFormatHint: 'Format: {format} (ex: {example})',
  dateFormatPattern: 'ZZ.LL.AAAA',
  dateFormatExample: '31.12.1990',
  invalidDateFormat: 'Va rugam sa folositi formatul: {format}',
  invalidDate: 'Data invalida',

  // Placeholders and descriptions
  discoverGenre: 'Descopera',

  // Time and duration
  m: 'M',
  now: 'acum',
  minuteAbbrev: 'min',
  hourAbbrev: 'h',
  dayAbbrev: 'z',
  monthAbbrev: 'lu',

  // History and viewing progress
  noViewingHistory: 'Niciun istoric de vizionare',
  episodesWillAppearHere: 'Episoadele vizionate vor aparea aici',
  history: 'Istoric',
  series: 'Seriale',
  noFavoritesYet: 'Inca nu ai favorite',
  addContentToFavorites: 'Adauga seriale si episoade la favorite pentru a le vedea aici',

  // My Purchases
  myPurchases: 'Achizitiile mele',
  purchased: 'Achizitionat',
  myPurchasesTitle: 'Episoadele tale deblocate',
  myPurchasesDescription: 'Gaseste aici toate episoadele Premium deblocate cu monedele tale. Continua sa vizionezi pentru a castiga mai multe monede!',
  tutorialStep1Title: 'Vizioneaza episoade',
  tutorialStep1Description: 'Castiga monede vizionand continut gratuit pe platforma.',
  tutorialStep2Title: 'Colecteaza recompense',
  tutorialStep2Description: 'Completeaza provocari si conecteaza-te zilnic pentru a castiga si mai multe monede.',
  tutorialStep3Title: 'Deblocheaza continut Premium',
  tutorialStep3Description: 'Foloseste monedele tale pentru a debloca episoade Premium exclusive.',
  goToRewards: 'Mergi la recompense',

  // Gamification notifications
  userSignupNotification: 'Bine ai venit! Ai castigat {coins} monede pentru crearea contului!',
  dailyVisitNotification: 'Ai castigat {coins} monede pentru vizita zilnica!',
  emailProvidedNotification: 'Ai castigat {coins} monede pentru furnizarea email-ului!',
  msisdnProvidedNotification: 'Ai castigat {coins} monede pentru furnizarea numarului de telefon!',
  birthDateProvidedNotification: 'Ai castigat {coins} monede pentru furnizarea datei de nastere!',
  completeProfileNotification: 'Ai castigat {coins} monede pentru completarea profilului!',
  pseudoProvidedNotification: 'Ai castigat {coins} monede pentru crearea unui pseudonim personalizat!',
  selectImageSource: 'Selecteaza sursa imaginii',
  takePhoto: 'Fa o fotografie',
  chooseFromLibrary: 'Alege din biblioteca',
  removeProfilePicture: 'Elimina poza de profil',
  removeProfilePictureConfirm: 'Esti sigur ca vrei sa elimini poza de profil?',
  profilePictureUpdated: 'Poza de profil actualizata cu succes',
  profilePictureRemoved: 'Poza de profil eliminata cu succes',
  failedToPickImage: 'Nu s-a putut selecta imaginea din biblioteca',
  failedToTakePhoto: 'Nu s-a putut face fotografia',
  failedToUploadImage: 'Incarcarea imaginii a esuat. Va rugam sa incercati din nou.',
  imageInappropriateContent: 'Imaginea contine continut inadecvat',
  failedToUpdateProfilePicture: 'Actualizarea pozei de profil a esuat',
  failedToRemoveProfilePicture: 'Eliminarea pozei de profil a esuat',
  watchEpisodeNotification: 'Ai castigat {coins} monede pentru vizionarea unui episod!',
  watchAdsNotification: 'Ai castigat {coins} monede pentru vizionarea reclamelor!',
  enableNotificationsNotification: 'Ai castigat {coins} monede pentru activarea notificarilor!',
  followSocialNotification: 'Ai castigat {coins} monede pentru ca ne urmaresti pe retelele sociale!',
  coinsEarnedNotification: 'Ai castigat {coins} monede!',
  coinsUsedForPremiumNotification: 'Ai folosit {coins} monede pentru a debloca acest episod Premium!',
  firstCoinsUsageNotification: 'Bine ai venit! Tocmai ai deblocat primul tau episod Premium cu monede!',

  // Reward Center
  rewardCenter: 'Centrul de recompense',
  rewards: 'Recompense',
  weeklyRanking: 'Clasament saptamanal',
  hallOfFame: 'Sala famei',
  thisWeeksTopPlayers: 'Cei mai buni jucatori ai saptamanii',
  allTimeChampions: 'Campionii tuturor timpurilor',
  totalCoinsAllTime: 'monede in total',
  coinsThisWeek: 'monede saptamana aceasta',
  achievements: 'realizari',
  dayStreakRecord: 'record de zile consecutive',
  you: 'Tu',
  noRankingData: 'Nu exista date de clasament',
  checkBackLaterRanking: 'Revino mai tarziu pentru clasamentele saptamanale',
  noHallOfFameData: 'Nu exista date pentru sala famei',
  checkBackLaterHallOfFame: 'Revino mai tarziu pentru clasamentele din toate timpurile',
  coins: 'Monede',
  days: 'zile',
  dailyCheckIn: 'Check-in zilnic',
  earnRewards: 'Castiga recompense',
  completed: 'Completat',
  claim: 'De facut',
  comingSoon: 'In curand',
  day: 'Zi',
  today: 'Maine',
  totalCoins: 'Monede totale',
  getCoins: 'Castiga Monede,',
  keepWatching: 'Continua sa Vizionezi',
  dayStreak: 'Zile consecutive',
  nextReward: 'Urmatoarea recompensa',
  availableTomorrow: 'Disponibil maine',
  weekProgress: 'Progresul saptamanii',
  serie: 'Serie',
  won: 'Castigat',
  tomorrow: 'Maine',
  toDo: 'De facut',
  firstWeek: 'Prima saptamana',
  secondWeek: 'A doua saptamana',
  amazingStreak: 'Serie incredibila! Continua asa!',
  overallProgress: 'Progres general',
  of: 'din',
  eventsCompleted: 'evenimente completate',
  ofMissionsCompleted: 'din misiuni completate',

  // Gamification event categories
  gamificationCategoryUser: 'Utilizator',
  gamificationCategoryProfile: 'Profil',
  gamificationCategoryContent: 'Conținut',
  gamificationCategoryGeneral: 'General',
  gamificationCategoryDailyMission: 'Misiune zilnică',
  gamificationCategoryWelcomeMissions: 'Misiuni de bun venit',
  gamificationCategoryWatchMissions: 'Misiuni de vizionare',
  gamificationCategoryOnceAYear: 'O dată pe an',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Completeaza misiuni si castiga monede!',
  gamificationFeature1Title: 'Creeaza-ti contul',
  gamificationFeature1Desc: 'Primeste {{coins}} monede de bun venit la inregistrare',
  gamificationFeature2Title: 'Vizioneaza episoade',
  gamificationFeature2Desc: 'Castiga {{coins}} monede pentru fiecare episod completat',
  gamificationFeature3Title: 'Urca in clasament',
  gamificationFeature3Desc: 'Compara-te cu alti membri in fiecare saptamana',
  gamificationFeature4Title: 'Deblocheaza episoade Premium',
  gamificationFeature4Desc: 'Foloseste monedele tale pentru a viziona si mai multe episoade',
  gamificationBonusText: '+{{coins}} monede gratuite la inregistrare!',
  createAccount: 'Creeaza contul meu',
  connectToYou: 'Conecteaza-te',

  // All Episodes Control
  allEpisodes: 'Toate episoadele',
  watchNow: 'Vizionează acum',
  previousEpisode: 'Anterior',
  nextEpisode: 'Urmator',

  // App availability
  appNotAvailable: 'Aceasta aplicatie nu este inca disponibila in tara si limba dumneavoastra.',
  appNotAvailableSubtext: 'Lucram pentru a extinde serviciul nostru in mai multe regiuni.',

  // Biometric authentication
  biometricLogin: 'Conectare biometrica',
  signInWithBiometric: 'Conectare cu biometrie',
  signInWithWebAuthn: 'Conectare cu WebAuthn',
  signInWithFaceId: 'Conectare cu Face ID',
  signInWithTouchId: 'Conectare cu Touch ID',
  enableBiometric: 'Activeaza conectarea biometrica',
  disableBiometric: 'Dezactiveaza conectarea biometrica',
  biometricNotAvailable: 'Autentificarea biometrica nu este disponibila pe acest dispozitiv',
  biometricAuthFailed: 'Autentificarea biometrica a esuat',
  biometricDataMissing: 'Datele de conectare biometrica lipsesc. Va rugam sa va conectati cu OTP, apoi reactivati conectarea biometrica din setarile profilului.',
  biometricNoUserData: 'Va rugam sa va conectati mai intai, apoi activati conectarea biometrica din setarile profilului.',
  biometricUnexpectedError: 'A aparut o eroare neasteptata. Va rugam sa va conectati cu OTP, apoi reactivati conectarea biometrica din setarile profilului.',
  biometricAuthCancelled: 'Autentificarea biometrica a fost anulata. Va rugam sa incercati din nou.',
  webauthnNotEnabled: 'Va rugam sa va conectati mai intai, apoi activati conectarea WebAuthn din setarile profilului.',
  webauthnCancelled: 'Autentificarea WebAuthn a fost anulata. Va rugam sa incercati din nou.',
  webauthnFailed: 'Autentificarea WebAuthn a esuat',
  biometricLoginEnabled: 'Conectarea biometrica a fost activata',
  biometricLoginDisabled: 'Conectarea biometrica a fost dezactivata',
  webauthnLoginEnabled: 'Conectarea WebAuthn a fost activata',
  webauthnLoginDisabled: 'Conectarea WebAuthn a fost dezactivata',
  faceIdLoginEnabled: 'Conectarea Face ID a fost activata',
  faceIdLoginDisabled: 'Conectarea Face ID a fost dezactivata',
  touchIdLoginEnabled: 'Conectarea Touch ID a fost activata',
  touchIdLoginDisabled: 'Conectarea Touch ID a fost dezactivata',
  androidBiometricLoginEnabled: 'Conectarea biometrica a fost activata',
  androidBiometricLoginDisabled: 'Conectarea biometrica a fost dezactivata',
  failedToEnableBiometric: 'Activarea conectarii biometrice a esuat',
  failedToDisableBiometric: 'Dezactivarea conectarii biometrice a esuat',
  failedToEnableWebauthn: 'Activarea conectarii WebAuthn a esuat',
  failedToDisableWebauthn: 'Dezactivarea conectarii WebAuthn a esuat',
  success: 'Succes',
  enableBiometricPrompt: 'Activati autentificarea biometrica pentru conectare rapida data viitoare?',
  enableBiometricPromptIos: 'Activati {authType} pentru conectare rapida data viitoare?',
  'Enable {{authType}}?': 'Activati {{authType}}?',
  'Would you like to enable {{authType}} for faster login?': 'Doriti sa activati {{authType}} pentru o conectare mai rapida?',
  '{{authType}} login has been enabled!': 'Conectarea {{authType}} a fost activata!',
  'Failed to enable {{authType}} login. Please try again later.': 'Activarea conectarii {{authType}} a esuat. Va rugam sa incercati mai tarziu.',
  biometricLoginTitle: 'Conectare biometrica',
  faceIdLogin: 'Conectare Face ID',
  touchIdLogin: 'Conectare Touch ID',
  useBiometricToSignIn: 'Foloseste amprenta sau recunoasterea faciala pentru conectare rapida',
  enableBiometricForSignIn: 'Activeaza amprenta sau recunoasterea faciala pentru conectare rapida',
  useFaceIdToSignIn: 'Foloseste Face ID pentru conectare rapida',
  enableFaceIdForSignIn: 'Activeaza Face ID pentru conectare rapida',
  useTouchIdToSignIn: 'Foloseste Touch ID pentru conectare rapida',
  enableTouchIdForSignIn: 'Activeaza Touch ID pentru conectare rapida',

  // Delete account
  deleteMyAccount: 'Sterge contul meu',
  deleteAccountConfirmation: 'Confirmare stergere',
  deleteAccountWarningNotSubscribed: 'Vom proceda la stergerea contului dumneavoastra. Nu veti mai putea accesa Hekaya dupa confirmare.\n\nCu toate acestea, va rugam sa retineti ca, in conformitate cu reglementarile, pastram in siguranta anumite date, de exemplu in scopul rezolvarii eventualelor dispute.',
  deleteAccountWarningSubscribed: 'Aveti in prezent un abonament activ. Va rugam sa il anulati mai intai. Veti gasi instructiunile de dezabonare in "Contul meu", "Dezabonare". Dupa anularea abonamentului, puteti proceda la stergerea contului.\n\nVom proceda la stergerea contului dumneavoastra. Nu veti mai putea accesa Hekaya dupa confirmare.\n\nCu toate acestea, va rugam sa retineti ca, in conformitate cu reglementarile, pastram in siguranta anumite date, de exemplu in scopul rezolvarii eventualelor dispute.',
  iConfirm: 'Confirm',
  deletingAccount: 'Se sterge contul...',
  accountDeleted: 'Cont sters',
  accountDeletedSuccess: 'Contul dumneavoastra a fost sters cu succes',
  accountDeleteError: 'Eroare la stergerea contului',
  activeSubscriptionErrorTitle: 'Abonament activ',
  activeSubscriptionErrorMessage: 'Trebuie sa anulati abonamentul inainte de a putea sterge contul.',
  gracePeriodErrorTitle: 'Stergerea nu este posibila inca',
  gracePeriodErrorMessage: 'Abonamentul a fost anulat, dar ramane activ pana la data expirarii. Veti putea sterge contul dupa ce aceasta perioada se incheie.',
  gracePeriodBannerTitle: 'Abonament anulat',
  gracePeriodBannerMessage: 'Abonamentul tau a fost anulat dar ramane activ pana la {{date}}. Pastrezi accesul la tot continutul Premium pana atunci.',
  notBilledDenyBannerTitle: 'Abonament suspendat',
  notBilledDenyBannerMessage: 'Abonamentul tau a fost suspendat temporar din cauza unei probleme de plata. Pentru a restabili accesul la serviciul nostru, va rugam sa reincarcati contul *9. Contul Hekaya va fi reactivat odata ce plata va fi procesata.',

  // Network connection
  noInternetConnection: 'Nu exista conexiune la internet. Va rugam sa verificati conexiunea si sa incercati din nou.',
  noInternetConnectionShort: 'Fara conexiune la internet',
  checkInternetConnection: 'Va rugam sa verificati conexiunea la internet',
  connectionRequired: 'Conexiune la internet necesara',
  dismiss: 'Continua offline',
  slowNetworkDetected: 'Retea lenta detectata',
  poorNetworkConnection: 'Conexiunea dumneavoastra are probleme. Incarcarea videoclipurilor dureaza mai mult decat de obicei.',
  loadingTime: 'Timp de incarcare',
  slowConnection: 'Conexiune lenta',

  // App version
  version: 'Versiune',

  // Image cache
  imageCacheStorage: 'Stocare cache imagini',
  cachedImages: 'Imagini in cache',
  storageUsed: 'Stocare utilizata',
  expiredImages: 'Imagini expirate',
  clearExpiredCache: 'Sterge expirate',
  clearAllCache: 'Sterge tot',
  clearing: 'Se sterge...',
  clearImageCache: 'Goleste cache-ul de imagini',
  clearImageCacheConfirmation: 'Esti sigur ca vrei sa stergi toate imaginile din cache? Acest lucru va elibera spatiu de stocare, dar imaginile vor trebui descarcate din nou.',
  clearCache: 'Goleste cache',
  cacheCleared: 'Cache golit cu succes! {{count}} imagini sterse.',
  expiredCacheCleared: 'Cache expirat golit! {{count}} imagini expirate eliminate.',
  noExpiredCache: 'Nu exista imagini expirate de sters.',
  failedToClearCache: 'Golirea cache-ului a esuat. Va rugam sa incercati din nou.',
  cacheAutoClears30Days: 'Imaginile sunt sterse automat dupa 30 de zile',
  info: 'Info',

  // Pagination
  scrollForMore: 'Deruleaza pentru mai mult',
  noMoreContent: 'Sfarsitul listei',
  loadingMore: 'Se incarca...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Conecteaza-te sau creeaza un cont gratuit',
    subscriptionWelcomeTitle: 'Multumim pentru abonament!',
    subscriptionWelcomeMessage: 'Ultimul pas: inregistreaza-te pentru a crea un cont sau conecteaza-te la unul existent pentru a incepe sa vizionezi.',
    emailPlaceholder: 'Adresa de email',
    phonePlaceholder: 'Numar de telefon',
    emailOrPhonePlaceholder: 'Email sau numar de telefon',
    continue: 'Continua',
    continueWithGoogle: 'Continua cu Google',
    continueWithApple: 'Continua cu Apple',
    termsPrefix: 'Continuand, accepti',
    termsOfService: 'Termenii si conditiile',
    privacyPolicy: 'Politica de confidentialitate',
    confirmEmail: 'Confirma adresa de email',
    confirmYourEmail: 'Confirma adresa ta de email',
    confirmPhone: 'Confirma numarul de telefon',
    confirmYourPhone: 'Confirma numarul tau de telefon',
    codeSentTo: 'Am trimis un cod la',
    codeSentToPhone: 'Am trimis un cod la',
    enterCodeBelow: 'Introdu-l mai jos pentru a verifica contul.',
    resendCode: 'Retrimite codul',
    resendIn: 'Retrimite in',
    verify: 'Verifica',
    connectingInProgress: 'Se conecteaza...',
    accountCreated: 'Cont creat',
    stayUpdatedTitle: 'Doresti sa fii la curent cu cele mai recente noutati?',
    stayUpdatedDescription: 'Am dori sa iti trimitem oferte personalizate, continut inspirational, sfaturi si informatii despre ultimele noastre inovatii.',
    learnMore: 'Afla mai mult',
    subscribe: 'Aboneaza-te',
    noThanks: 'Nu, multumesc',
    enterEmailOrPhone: 'Va rugam sa introduceti email-ul sau numarul de telefon',
    sendFailed: 'Trimiterea codului a esuat. Va rugam sa incercati din nou.',
    enterCompleteCode: 'Va rugam sa introduceti codul complet de 6 cifre',
    verificationFailed: 'Verificarea a esuat. Va rugam sa incercati din nou.',
    invalidCode: 'Cod invalid. Va rugam sa incercati din nou.',
    codeExpired: 'Codul a expirat. Va rugam sa solicitati unul nou.',
    checkSpamFolder: 'Nu uita sa verifici folderul de spam',
    dcbValidatingSubscription: 'Se valideaza abonamentul...',
    dcbActivating: 'Se activeaza abonamentul...',
    dcbSuccessTitle: 'Abonament activat!',
    dcbSuccessMessage: 'Abonamentul tau a fost activat cu succes. Poti acum sa te bucuri de tot continutul.',
    dcbStartWatching: 'Incepe vizionarea',
    dcbErrorTitle: 'Eroare de activare',
    dcbErrorRetry: 'A aparut o eroare la activarea abonamentului. Va rugam sa incercati din nou.',
    dcbPaymentNotFound: 'Abonament negasit. Va rugam sa verificati link-ul sau sa contactati suportul.',
    dcbRetryButton: 'Reincearca',
    dcbIdentityMismatchPhone: 'Numarul de telefon folosit pentru abonament este {{identifier}}. Va rugam sa folositi acest numar pentru a crea contul.',
    dcbIdentityMismatchEmail: 'Email-ul folosit pentru abonament este {{identifier}}. Va rugam sa folositi acest email pentru a crea contul.',
    dcbRecoveryBanner: 'Un abonament in asteptare a fost detectat. Creati contul pentru a-l accesa.',
    dcbAlreadySubscribed: 'Deja abonat prin plata mobila?',
    dcbEnterPhone: 'Introduceti numarul de telefon folosit la plata:',
    dcbRecoverButton: 'Recupereaza',
    dcbMsisdnNotFound: 'Nu s-a gasit niciun abonament in asteptare pentru acest numar.',
    dcbMsisdnRecoveryFailed: 'Recuperarea a esuat. Va rugam sa incercati din nou.',
    invalidPhoneNumber: 'Numar de telefon invalid.',
  },
  and: 'si',
  smartBannerSubtitle: 'Experienta mai buna in aplicatie',
  smartBannerOpen: 'DESCHIDE',
  paymentVerifying: 'Se verifica abonamentul...',
  paymentSuccessTitle: 'Abonament activat!',
  paymentSuccessMessage: 'Felicitari, ai acum acces la tot continutul Premium.',
  paymentSuccessButton: 'Incepe vizionarea',
  paymentPendingMessage: 'Plata ta a fost primita. Abonamentul va fi activ in curand.',
  paymentRefreshButton: 'Reimprospatare',
  redirectingToPayment: 'Redirectionare catre pagina de plata...',
  webPaymentIframeErrorTitle: 'Pagina de plata indisponibila',
  webPaymentIframeErrorMessage: 'Pagina de plata nu a putut fi incarcata in aplicatie. O poti deschide intr-un tab nou.',
  webPaymentOpenExternal: 'Deschide intr-un tab nou',

  // Premium subscription card
  enterPremiumExperience: 'Intra in',
  popular: 'POPULAR',
  mobileInvoice: 'Factura mobila',
  mobileInvoicePrice: '9,99 EUR/luna',
  mobileInvoiceDescription: 'Plata pe factura de telefon. Simplu si rapid.',
  cardAppleGooglePay: 'Card / Apple Pay / Google Pay',
  cardPaymentDescription: 'Plata securizata prin card, Apple Pay sau Google Pay.',
  dcbPaymentOfferDescription: 'Plata pe factura telefonului. Simplu si rapid.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Abonament facturat si gestionat prin contul Apple App Store.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Abonament facturat si gestionat prin contul Google Play Store.',
  upgradeToPremium: 'Treci la Premium',
  cancelAnytimeNoCommitment: 'Anuleaza oricand · Fara angajament',
  whyBecomeVip: 'De ce sa devii VIP?',
  joinPremiumCommunity: 'Alatura-te comunitatii Premium Hekaya',
  unlimitedAccessShort: 'Acces la toate serialele si episoadele fara limita.\nVizioneaza oricand doresti, de oriunde.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Abonament zilnic',
  dcbOfferWeekly: 'Abonament săptămânal',
  dcbOfferMonthly: 'Abonament lunar',
  dcbOfferQuarterly: 'Abonament trimestrial',
  dcbOfferYearly: 'Abonament anual',
  dcbOfferRecurring: 'Abonament recurent',
  dcbSubscriptionValidity: 'Valabil până la {{date}}',
};

export type TranslationKey = keyof typeof ro;
